if (!customElements.get('walkesim-plan-selector')) {
  customElements.define('walkesim-plan-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent);
      const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.plans = this.catalog.plans.map(plan => ({ ...plan, variant: variants.find(variant => variant.sku === plan.sku) })).filter(plan => plan.variant);
      this.form = this.querySelector('form');
      this.input = this.querySelector('[data-variant-input]');
      this.list = this.querySelector('.wsj-list');
      this.bar = this.querySelector('.wsj-bar');
      this.dialog = this.querySelector('.wsj-dialog');
      document.body.append(this.bar, this.dialog);
      this.selections = new Map();
      const requested = this.plans.find(plan => String(plan.variant.id) === this.dataset.selected && plan.variant.available);
      this.selected = requested || this.plans.find(plan => plan.variant.available) || this.plans[0];
      if (!this.selected) return;
      if (this.catalog.coverage?.length > 1) this.setupCoverage();
      this.category = this.selected.category;
      this.day = requested ? requested.days : null;
      if (requested) this.selections.set(this.key(requested), requested);
      this.tabs = this.querySelector('.wsj-tabs');
      this.tabs.replaceChildren();
      ['Unlimited', 'Daily', 'Total'].filter(category => this.plans.some(plan => plan.category === category)).forEach(category => {
        const button = this.element('button', '', category);
        button.type = 'button';
        button.dataset.category = category;
        button.addEventListener('click', () => {
          this.category = category;
          this.selected = this.plans.find(plan => plan.category === category && plan.variant.available) || this.plans.find(plan => plan.category === category);
          this.day = null;
          this.render();
        });
        this.tabs.append(button);
      });
      this.tabs.hidden = this.tabs.children.length < 2;
      this.bar.querySelector('.wsj-details').addEventListener('click', () => this.dialog.showModal());
      this.dialog.querySelector('.wsj-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.form.addEventListener('submit', event => this.submit(event));
      const placeFlag = () => {
        if (!this.isConnected) return;
        const info = document.getElementById('ProductInfo-' + this.dataset.section);
        const title = info?.querySelector('.ws-product-title-row') || info?.querySelector('.product__title');
        if (title && !title.querySelector('.wsj-heading-flag')) {
          this.flag = this.dialog.querySelector('.wsj-flag').cloneNode();
          this.flag.className = 'wsj-heading-flag';
          title.prepend(this.flag);
        }
        if (title && this.coverageButton && !this.coverageButton.isConnected) title.after(this.coverageButton);
      };
      this.onReady = () => requestAnimationFrame(placeFlag);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      else this.onReady();
      this.render();
    }
    key(plan) { return plan.category + ':' + plan.days; }
    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }
    money(plan) {
      return '$' + (plan.variant.price / 100).toFixed(2) + ' USD';
    }
    dataLabel(plan) {
      return plan.category === 'Unlimited' ? plan.usage : plan.allowance + (plan.category === 'Daily' ? ' / day' : '');
    }
    daySelection(day) {
      const plans = this.plans.filter(plan => plan.category === this.category && plan.days === day);
      const available = plans.filter(plan => plan.variant.available);
      return (available.length ? available : plans).slice().sort((a, b) => a.variant.price - b.variant.price || a.sort_order - b.sort_order)[0];
    }
    levels() {
      return this.category === 'Unlimited'
        ? [{ key: 'usage', label: 'Data' }, { key: 'service', label: 'Service' }, { key: 'network', label: 'Network' }, { key: 'speed', label: 'Speed' }]
        : [{ key: 'allowance', label: this.category === 'Daily' ? 'Daily high-speed data' : 'Data' }, { key: 'usage', label: 'After high-speed data' }, { key: 'network', label: 'Network' }, { key: 'speed', label: 'Speed' }];
    }
    value(plan, key) {
      if (key === 'network') {
        const peers = this.plans.filter(item => item.category === plan.category && item.days === plan.days && item.usage === plan.usage && item.allowance === plan.allowance && item.network === plan.network && item.speed === plan.speed);
        if (new Set(peers.map(item => item.special_label)).size > 1) {
          return plan.network + ' · ' + (plan.special_label === 'Standard unlimited' ? 'Standard' : plan.special_label);
        }
      }
      return key === 'service' ? (plan.note2 === 'Support Tiktok & GPT' ? 'Support TikTok & GPT' : 'Standard') : plan[key];
    }
    render() {
      if (this.day !== null) this.selections.set(this.key(this.selected), this.selected);
      [...this.tabs.children].forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
      this.list.replaceChildren();
      const days = [...new Set(this.plans.filter(plan => plan.category === this.category).map(plan => plan.days))].sort((a, b) => a - b);
      days.forEach(day => {
        const active = day === this.day;
        const plan = active ? this.selected : this.daySelection(day);
        const group = this.element('section', 'wsj-day');
        group.dataset.days = day;
        let dayText = day + (day === 1 ? ' Day' : ' Days');
        if (active && this.category === 'Daily') dayText += ' ($' + (plan.variant.price / 100 / day).toFixed(2) + '/day)';
        const heading = this.element('h3', 'wsj-group', dayText);
        group.append(heading);
        const card = this.element('div', 'wsj-card' + (active ? ' wsj-card--selected' : ''));
        const toggle = this.element('button', 'wsj-card-toggle');
        toggle.type = 'button';
        toggle.setAttribute('aria-expanded', String(active));
        toggle.append(this.element('span', 'wsj-data', this.dataLabel(plan)), this.element('span', 'wsj-price', this.money(plan)));
        toggle.addEventListener('click', () => { this.day = active ? null : day; this.selected = this.daySelection(day); this.render(); });
        card.append(toggle);
        if (active) {
          const options = this.element('div', 'wsj-options');
          let candidates = this.plans.filter(item => item.category === this.category && item.days === day);
          const levels = this.levels();
          levels.forEach((level, index) => {
            const choices = [...new Set(candidates.map(item => this.value(item, level.key)))];
            if (choices.length > 1) {
              const field = this.element('fieldset', 'wsj-option-group');
              field.dataset.level = level.key;
              field.append(this.element('legend', '', level.label));
              const pills = this.element('div', 'wsj-pills');
              choices.forEach(value => {
                const matches = candidates.filter(item => this.value(item, level.key) === value);
                const button = this.element('button', 'wsj-pill', value);
                button.type = 'button';
                button.setAttribute('aria-pressed', String(this.value(this.selected, level.key) === value));
                button.disabled = !matches.some(item => item.variant.available);
                button.addEventListener('click', () => {
                  const available = matches.filter(item => item.variant.available);
                  this.selected = available.find(item => levels.slice(index + 1).every(next => this.value(item, next.key) === this.value(this.selected, next.key))) || available[0];
                  this.render();
                });
                pills.append(button);
              });
              field.append(pills);
              options.append(field);
            }
            candidates = candidates.filter(item => this.value(item, level.key) === this.value(this.selected, level.key));
          });
          card.append(options);
          const notes = this.element('div', 'wsj-selected-notes');
          if (plan.note1) notes.append(this.element('p', 'wsj-reset', plan.note1));
          card.append(notes);
          card.dataset.sku = plan.sku;
          card.dataset.variantId = plan.variant.id;
          if (!plan.variant.available) card.append(this.element('p', '', 'Unavailable'));
        }
        group.append(card);
        this.list.append(group);
      });
      this.update();
    }
    update() {
      if (this.coverageDialog) this.renderCoverage(this.selected);
      const buttons = [...this.bar.querySelectorAll('[type=submit]'), ...this.dialog.querySelectorAll('[type=submit]')];
      if (this.day === null) {
        this.input.disabled = true;
        this.input.value = '';
        this.bar.hidden = true;
        buttons.forEach(button => button.disabled = true);
        document.body.classList.remove('wsj-has-bar');
        const url = new URL(location.href);
        url.searchParams.delete('variant');
        history.replaceState({}, '', url);
        return;
      }
      document.body.classList.add('wsj-has-bar');
      const plan = this.selected;
      this.input.value = plan.variant.id;
      this.input.disabled = !plan.variant.available;
      const planSummary = [this.dataLabel(plan), plan.days + ' Days'];
      if (!(this.catalog.coverage?.length > 1)) planSummary.push(plan.network);
      this.bar.querySelector('.wsj-summary').textContent = planSummary.join(' · ');
      this.bar.querySelector('.wsj-bar-price').textContent = this.money(plan);
      [...this.bar.querySelectorAll('[type=submit]'), ...this.dialog.querySelectorAll('[type=submit]')].forEach(button => button.disabled = !plan.variant.available);
      this.bar.hidden = false;
      this.renderFacts(plan);
      const url = new URL(location.href);
      url.searchParams.set('variant', plan.variant.id);
      history.replaceState({}, '', url);
    }
    renderFacts(plan) {
      const activationPolicy = 'The validity period starts once the eSIM connects to a supported network and begins using data for internet access. We recommend adding the eSIM after you arrive at your destination. You can install the eSIM in advance, but please remember to turn it off immediately after installation to prevent the validity period from starting earlier than expected.';
      let hotspot = 'YES';
      let fup = plan.note1;
      let policy = activationPolicy;
      const specialParts = plan.special.split(/\s*\|\s*/).filter(Boolean);
      specialParts.forEach(part => {
        const limit = part.match(/Hotspot limit:\s*(\d+\s*GB)/i);
        if (limit) hotspot += ' — ' + limit[1] + ' limit';
        if (/high-speed data per day, then/i.test(part)) {
          if (!fup.includes(part)) fup += ' ' + part;
        } else if (/activate upon arrival/i.test(part)) {
          policy += '\n' + part;
        }
      });
      const other = plan.special ? [plan.special] : [];
      if (plan.note2 && !['Support Tiktok & GPT', 'Support Tiktok & GPT (Android use on the web version)'].includes(plan.note2)) other.push(plan.note2);
      const facts = [
        ['Data type', plan.category], ['Data', this.dataLabel(plan)], ['Validity', plan.days + ' Days'], ['Price', this.money(plan)],
        ['Coverage', plan.coverage || (this.catalog.coverage || []).map(destination => destination.name).join(', ')], ['Network', plan.network], ['Speed', plan.speed], ['Plan Type', 'Data Only'],
        ['Tethering / Hotspot', hotspot], ['Phone Number', 'NO'], ['Top-up Option', 'Not available'],
        ['eKYC (Identity Verification)', plan.ekyc]
      ];
      if (plan.activation_type) facts.push(['Activation Type', plan.activation_type === 'ACTIVEDBYDEVICE' ? 'Activated by Device' : plan.activation_type]);
      facts.push(['Fair Usage Policy (FUP)', fup + '\n' + plan.validity]);
      facts.push(['Activation Policy', policy]);
      if (other.length) facts.push(['Other Information', other.join('\n')]);
      const container = this.dialog.querySelector('.wsj-facts');
      container.replaceChildren();
      facts.forEach(([label, value]) => {
        const long = ['Fair Usage Policy (FUP)', 'Activation Policy', 'Other Information'].includes(label);
        const row = this.element('div', long ? 'wsj-fact wsj-fact--long' : 'wsj-fact');
        row.append(this.element('dt', '', label), this.element('dd', '', value));
        container.append(row);
      });
    }
    setupCoverage() {
      this.coverageButton = this.element('button', 'wsj-coverage-trigger');
      this.coverageButton.type = 'button';
      const titleId = 'WalkesimCoverage-' + this.dataset.section;
      this.coverageButton.setAttribute('aria-haspopup', 'dialog');
      this.coverageButton.setAttribute('aria-controls', titleId + '-dialog');
      const icon = this.element('img', 'wsj-coverage-icon');
      icon.src = this.catalog.country.flag_image;
      const countryName = this.catalog.country.name;
      const keyword = /esim/i.test(countryName) ? countryName : countryName + ' eSIM';
      icon.alt = this.dataset.imageAlt || keyword;
      icon.title = this.dataset.imageTitle || '';
      icon.width = 24;
      icon.height = 24;
      this.coverageButton.append(icon, this.element('span', '', this.dataset.coverageButton));
      this.coverageDialog = this.element('dialog', 'wsj-dialog wsj-coverage-dialog');
      this.coverageDialog.id = titleId + '-dialog';
      this.coverageDialog.setAttribute('aria-labelledby', titleId);
      const head = this.element('div', 'wsj-coverage-head');
      const title = this.element('h2', '', this.dataset.coverageTitle);
      title.id = titleId;
      const close = this.element('button', 'wsj-close', '×');
      close.type = 'button';
      close.setAttribute('aria-label', this.dataset.coverageClose);
      close.addEventListener('click', () => this.coverageDialog.close());
      this.coverageCaption = this.element('p', 'wsj-coverage-caption');
      this.coverageSearch = this.element('input', 'wsj-coverage-search');
      this.coverageSearch.type = 'search';
      this.coverageSearch.hidden = this.catalog.coverage.length <= 20;
      this.coverageSearch.placeholder = this.dataset.coverageSearch;
      this.coverageSearch.setAttribute('aria-label', this.dataset.coverageSearch);
      this.coverageSearch.addEventListener('input', () => this.renderCoverage(this.selected));
      head.append(title, close, this.coverageCaption, this.coverageSearch);
      this.coverageList = this.element('dl', 'wsj-coverage-list');
      this.coverageEmpty = this.element('p', 'wsj-coverage-empty', this.dataset.coverageEmpty);
      this.coverageEmpty.hidden = true;
      this.coverageDialog.append(head, this.coverageList, this.coverageEmpty);
      document.body.append(this.coverageDialog);
      this.coverageButton.addEventListener('click', () => {
        this.coverageSearch.value = '';
        this.renderCoverage(this.selected);
        this.coverageDialog.showModal();
      });
      this.coverageDialog.addEventListener('close', () => this.coverageButton.focus({ preventScroll: true }));
      this.coverageDialog.addEventListener('click', event => {
        if (event.target !== this.coverageDialog) return;
        const bounds = this.coverageDialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.coverageDialog.close();
      });
    }
    countryNetworks(plan) {
      const names = this.catalog.coverage.map(country => country.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      const pattern = new RegExp('(?:^|;\\s*)(' + names.join('|') + '):\\s*', 'g');
      const network = plan.network || '';
      const matches = [...network.matchAll(pattern)];
      const countries = new Map();
      matches.forEach((match, index) => {
        const operators = network.slice(match.index + match[0].length, matches[index + 1]?.index ?? network.length).trim();
        const entries = countries.get(match[1]) || [];
        if (operators && !entries.includes(operators)) entries.push(operators);
        countries.set(match[1], entries);
      });
      return new Map([...countries].map(([country, entries]) => [country, entries.join('; ')]));
    }
    normalizeCoverageSearch(value) {
      return value.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase().replace(/[\p{P}\p{Z}\p{S}]/gu, '');
    }
    coverageSearchNames(country) {
      if (!this.coverageSearchIndex) {
        this.coverageSearchIndex = new Map();
        const locales = [...new Set([
          document.documentElement.lang, ...(navigator.languages || []),
          'en', 'zh-Hans', 'zh-Hant', 'ja', 'ko', 'fr', 'de', 'es', 'pt', 'it',
          'nl', 'ru', 'uk', 'pl', 'cs', 'sk', 'hu', 'ro', 'bg', 'el', 'tr',
          'ar', 'he', 'fa', 'hi', 'bn', 'ur', 'th', 'vi', 'id', 'ms', 'fil',
          'sv', 'da', 'nb', 'fi', 'et', 'lv', 'lt', 'hr', 'sr', 'sl', 'sw', 'af'
        ].filter(Boolean))];
        const regionNames = [];
        if (typeof Intl.DisplayNames === 'function') {
          locales.forEach(locale => {
            try { regionNames.push(new Intl.DisplayNames([locale], { type: 'region', fallback: 'none' })); }
            catch (_) {}
          });
        }
        const aliases = {
          CN: ['中国', '中國', '中国大陆', '中國大陸', 'Mainland China', 'PRC'],
          HK: ['香港', 'Hong Kong SAR'], MO: ['澳门', '澳門', 'Macau', 'Macao SAR'],
          TW: ['台湾', '台灣'], US: ['美国', '美國', 'USA', 'United States of America'],
          GB: ['英国', '英國', 'UK', 'Great Britain'], KR: ['韩国', '韓國', 'South Korea'],
          AE: ['阿联酋', '阿聯酋', 'UAE']
        };
        this.catalog.coverage.forEach(item => {
          const code = String(item.code || '').toUpperCase();
          const names = [item.name, code, ...(aliases[code] || [])];
          if (/^[A-Z]{2}$/.test(code)) regionNames.forEach(displayNames => {
            try { const name = displayNames.of(code); if (name) names.push(name); }
            catch (_) {}
          });
          this.coverageSearchIndex.set(item.code, names.map(name => this.normalizeCoverageSearch(name)));
        });
      }
      return this.coverageSearchIndex.get(country.code) || [this.normalizeCoverageSearch(country.name)];
    }
    renderCoverage(plan) {
      const networks = this.countryNetworks(plan);
      this.coverageCaption.textContent = this.dataset.coverageIntro + ' ' + this.dataLabel(plan) + ' · ' + plan.days + ' Days';
      const query = this.coverageSearch.hidden ? '' : this.normalizeCoverageSearch(this.coverageSearch.value.trim());
      this.coverageList.replaceChildren();
      this.catalog.coverage.forEach(country => {
        if (query && !this.coverageSearchNames(country).some(name => name.includes(query))) return;
        const row = this.element('div', 'wsj-coverage-row');
        row.dataset.countryCode = country.code;
        const name = this.element('dt');
        const flag = this.element('span', 'wsj-coverage-flag', country.flag || '');
        flag.setAttribute('aria-hidden', 'true');
        name.append(flag, this.element('span', '', country.name));
        row.append(name, this.element('dd', '', networks.get(country.name) || this.dataset.coverageUnspecified));
        this.coverageList.append(row);
      });
      this.coverageEmpty.hidden = this.coverageList.children.length > 0;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || this.day === null || !this.selected.variant.available) return;
      const buttons = [...this.bar.querySelectorAll('[type=submit]'), ...this.dialog.querySelectorAll('[type=submit]')];
      const error = this.bar.querySelector('.wsj-error');
      error.hidden = true;
      this.busy = true;
      buttons.forEach(button => button.disabled = true);
      const checkout = event.submitter?.dataset.action !== 'cart';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: this.selected.variant.id, quantity: 1 }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this plan. Please try again.');
        location.assign((window.Shopify?.routes?.root || '/') + (checkout ? 'checkout' : 'cart'));
      } catch (failure) {
        error.textContent = failure.message;
        error.hidden = false;
        this.dialog.close();
        this.busy = false;
        buttons.forEach(button => button.disabled = !this.selected.variant.available);
      }
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.onReady);
      this.bar?.remove();
      this.dialog?.remove();
      this.flag?.remove();
      this.coverageButton?.remove();
      this.coverageDialog?.remove();
      document.body.classList.remove('wsj-has-bar');
    }
  });
}
